var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBookPinkImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_613307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.0161 28.9514V9.51587C1.33065 9.69732 0.645099 9.91913 0 10.1207V34.6571C5.4117 33.1613 11.1623 33.4583 16.3911 35.5038C12.8378 31.911 7.99673 29.886 2.94358 29.8788C2.4358 29.8681 2.02687 29.4591 2.0161 28.9514Z",
    fill: "#F13B86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.91107 4.21362L3.85059 28.1249C9.78538 28.4322 15.3204 31.2107 19.1127 35.7862V12.9838C15.6504 7.89256 10.0515 4.66243 3.91107 4.21362Z",
    fill: "#F13B86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.9841 9.5564V28.9717C37.9734 29.4794 37.5644 29.8884 37.0567 29.8991C32.0148 29.9036 27.1853 31.9299 23.6494 35.5241V35.5443C28.861 33.4915 34.5971 33.1803 40.0002 34.6571V10.1611C39.3551 9.93943 38.6898 9.71772 37.9841 9.5564Z",
    fill: "#F13B86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.1697 4.21362C30.0047 4.61783 24.3753 7.85693 20.9277 12.9838V35.7862C24.7154 31.2157 30.242 28.4378 36.1697 28.1249V4.21362Z",
    fill: "#F13B86"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookPinkImg2);
export default __webpack_public_path__ + "static/media/OpenBookPinkImg (2).d9ed87d3288fe440cb9bc8a2ef7f0a95.svg";
export { ForwardRef as ReactComponent };